import React from 'react'
import { useParams, useLocation, useNavigate } from 'react-router-dom'

const withRouter = (Component) => {
  const Wrapper = (props) => {
    const params = useParams()
    const location = useLocation()
    const navigate = useNavigate()

    return (
      <Component
        {...props}
        params={params}
        location={location}
        navigate={navigate}
      />
    )
  }

  return Wrapper
}

export default withRouter
